
















































































































import VueOptions from '@utils/VueOptions'
import EventFeed from '@ui/EventFeed/EventFeed'
import states from '@assets/states.json'
import dma from '@assets/dma.json'
import SendBrandInvitationTriggerModal from '@triggers/BrandRep/SendBrandInvitationTriggerModal'
import RecessVerifyTriggerModal from '@triggers/BrandRep/RecessVerifyTriggerModal'
import RecessUnverifyTriggerModal from '@triggers/BrandRep/RecessUnverifyTriggerModal'
import ExportEventFeedCSVTriggerModal from '@triggers/EventFeed/ExportEventFeedCSVTriggerModal'
import ShoppingCart from '@ui/EventFeed/ShoppingCart'
import EventScheduleSelector from '@ui/EventSchedule/EventScheduleSelector'

settings =
  name: "EventFeedShowPage"
  components: { EventFeed, SendBrandInvitationTriggerModal, RecessVerifyTriggerModal, RecessUnverifyTriggerModal, ExportEventFeedCSVTriggerModal, ShoppingCart, EventScheduleSelector }
  resources:
    scanner:
      resourceName: 'scanner'
      slug: 'scanners/:eventFeedId'
    brand_rep_invitations:
      resourceName: 'brand_rep_invitations'
      slug: 'brand_rep_invitations'
    brand_rep:
      resourceName: 'brand_rep'
      slug: '/brand_reps/:scanner.brand_rep.id'
      fetch: false

  vue:
    data: ->
      state_options: states
      dma_options: dma

    computed:
      hasMember: -> @scanner.brand_rep.member_id
      brandRepId: -> @scanner.brand_rep.id

    methods:
      sendBrandInvitationTrigger: ->
        payload =
          invited_by: ''
          brand_rep_id: @scanner.brand_rep.id
        @$refs.sendBrandInvitationTrigger.fire(payload)
      onBrandRepInvitationsSendBrandInvitation: ->
        @$refs.sendBrandInvitationTrigger.close()

      recessVerifyTrigger: ->
        @$refs.recessVerifyTrigger.fire()
      onBrandRepRecessVerify: ->
        @$refs.recessVerifyTrigger.close()
        @fetch('scanner')

      recessUnverifyTrigger: ->
        @$refs.recessUnverifyTrigger.fire()
      onBrandRepRecessUnverify: ->
        @$refs.recessUnverifyTrigger.close()
        @fetch('scanner')
        
      exportEventFeedCSVTrigger: ->
        @$refs.exportEventFeedCSVTrigger.fire()
      onScannerCsvExport: ->
        @$refs.exportEventFeedCSVTrigger.close()
      

export default VueOptions.vue settings
